var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"16px","width":"100px"},style:({ backgroundColor: _vm.value })})
}
var staticRenderFns = []

export { render, staticRenderFns }